module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance@3x.197aa68d.png";